/* eslint-disable react-refresh/only-export-components */
import { createFileRoute, Link } from "@tanstack/react-router";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import { services } from "@/data";

export const Route = createFileRoute("/_public/services/")({
  component: ServicesPage,
});

function ServicesPage() {
  return (
    <>
      <Helmet>
        <title>Tax Services | Rosewood Tax Consultancy Kenya</title>
        <meta
          name="description"
          content="Comprehensive tax services in Kenya: KRA registration, tax returns, eTIMS compliance, bookkeeping, tax advisory, audit defence, international tax, and training."
        />
      </Helmet>

      <section className="bg-cream pt-16 pb-14">
        <div className="max-w-7xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1 className="text-4xl md:text-5xl font-semibold text-charcoal mb-4">
              Every Tax Need, Covered
            </h1>
            <p className="text-lg text-neutral-800 max-w-2xl">
              From basic KRA compliance to complex international tax structures —
              our nine service lines cover every dimension of your tax life.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service, i) => (
              <motion.div
                key={service.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                className={i === 0 ? "lg:col-span-2" : ""}
              >
                <Link
                  to={`/services/${service.slug}` as never}
                  className="group block h-full"
                >
                  <div className="relative h-64 md:h-72 rounded-xl overflow-hidden duration-300">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
                    <div className="absolute bottom-0 left-0 right-0 p-5 text-white">
                      <h2 className="text-xl font-semibold mb-1">
                        {service.title}
                      </h2>
                      <p className="text-sm text-white/80 line-clamp-2 leading-relaxed">
                        {service.shortDescription}
                      </p>
                      <span className="inline-block mt-2 text-xs font-medium uppercase tracking-wider text-gold-light border-b border-transparent group-hover:border-gold-light/80 transition-all">
                        Explore
                      </span>
                    </div>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}